import { render } from "./ButtonHeartIcon.vue?vue&type=template&id=17b10a9c"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__